export function loadScript(scriptLocation: string): void {
	const existing = document.querySelector(`script[src="${scriptLocation}"]`);
	if (existing) {
		return;
	}
	const v = document.createElement('script');

	v.type = 'text/javascript';
	v.async = true;
	v.defer = true;
	v.src = scriptLocation;
	document.body.appendChild(v);
}

export function loadCss(url: string): void {
	const existing = document.querySelector(`link[href="${url}"]`);
	if (existing) {
		return;
	}
	const style = document.createElement('link');
	style.type = 'text/css';
	style.rel = 'stylesheet';
	style.href = url;
	document.head.appendChild(style);
}
